<template>
    <div>
      <h1 class="text-success">Formulario de Dosis para Mujer Embarazada</h1>
      <div class="alert alert-info" role="alert">
      <strong>Nota:</strong> Este formulario agregará el número de dosis acerca del tipo vacuna en el Esquema de vacunación para
embarazadas.
    </div>
      <div class="mt-4">
        <button @click="showCreateForm" class="btn btn-primary">Agregar dosis</button>
      </div>
  
      <!-- Lista de VacunaDosisMujer en una tabla -->
      <div class="table-responsive mt-3">
        <table class="table table-bordered">
          <thead class="thead-light">
            <tr>
              <th>Dosis</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="vacunaDosisMujer in vacunaDosisMujerList" :key="vacunaDosisMujer._id">
              <td>{{ vacunaDosisMujer.dosis }}</td>
              <td>
                <div class="btn-group" role="group">
                  <button @click="editVacunaDosisMujer(vacunaDosisMujer)" class="btn btn-warning btn-sm">Editar</button>
                  <button @click="deleteVacunaDosisMujer(vacunaDosisMujer._id)" class="btn btn-danger btn-sm">Eliminar</button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
  
      <!-- Formulario de creación/editar -->
      <div v-if="showForm" class="mt-4">
        <h2 class="h4">{{ isEditing ? 'Editar VacunaDosisMujer' : 'Agregar VacunaDosisMujer' }}</h2>
        <form @submit.prevent="isEditing ? updateVacunaDosisMujer() : createVacunaDosisMujer()" class="form-inline">
          <div class="form-group mr-2">
            <label for="dosis" class="mr-2">Dosis</label>
            <input v-model="formData.dosis" type="number" id="dosis" required class="form-control form-control-lg" min="1" max="10"/>
          </div>
          <div class="btn-group">
            <button type="submit" class="btn btn-primary">{{ isEditing ? 'Guardar Cambios' : 'Agregar' }}</button>
            <button @click="cancelEdit" class="btn btn-secondary">Cancelar</button>
          </div>
        </form>
      </div>
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  import swal from 'sweetalert';
  import { BASE_URL } from '../store/config';
  
  export default {
    computed: {
      currentUser() {
        return this.$store.state.auth.user;
      },
    },
    data() {
      return {
        vacunaDosisMujerList: [],
        showForm: false,
        formData: {
          dosis: 0,
        },
        isEditing: false,
        editingVacunaDosisMujerId: null,
      };
    },
    methods: {
      async fetchVacunaDosisMujer() {
        try {
          const response = await axios.get(`${BASE_URL}/api/vacunadosismujer`, {
            headers: {
              'x-access-token': this.$store.state.auth.user.accessToken,
            },
          });
          this.vacunaDosisMujerList = response.data;
        } catch (error) {
          console.error('Error al obtener VacunaDosisMujer:', error);
        }
      },
      showCreateForm() {
        this.showForm = true;
        this.isEditing = false;
        this.formData = {
          dosis: 0,
        };
      },
      async createVacunaDosisMujer() {
        try {
          await axios.post(`${BASE_URL}/api/vacunadosismujer`, this.formData, {
            headers: {
              'x-access-token': this.$store.state.auth.user.accessToken,
            },
          });
          swal({
            title: '¡Información Guardada!',
            text: 'La información de VacunaDosisMujer ha sido guardada correctamente.',
            icon: 'success',
            button: 'OK',
          });
          this.clearFields();
          this.fetchVacunaDosisMujer();
          this.showForm = false;
        } catch (error) {
          swal({
            title: 'Error',
            text: `Hubo un error al guardar la información de VacunaDosisMujer. \n ${error.response.data.message}.`,
            icon: 'error',
            button: 'OK',
          });
        }
      },
      clearFields() {
        this.formData = {
          dosis: 0,
        };
      },
      deleteVacunaDosisMujer(id) {
        swal({
          title: '¿Estás seguro?',
          text: 'Una vez eliminado, no podrás recuperar este registro.',
          icon: 'warning',
          buttons: ['Cancelar', 'Eliminar'],
          dangerMode: true,
        })
        .then((confirmation) => {
          if (confirmation) {
            this.performVacunaDosisMujerDeletion(id);
          }
        });
      },
      async performVacunaDosisMujerDeletion(id) {
        try {
          await axios.delete(`${BASE_URL}/api/vacunadosismujer/${id}`, {
            headers: {
              'x-access-token': this.$store.state.auth.user.accessToken,
            },
          });
          swal({
            title: '¡Información Eliminada!',
            text: 'La información de VacunaDosisMujer ha sido eliminada correctamente.',
            icon: 'success',
            button: 'OK',
          });
          this.fetchVacunaDosisMujer();
        } catch (error) {
          swal({
            title: 'Error',
            text: 'Hubo un error al eliminar la información de VacunaDosisMujer.',
            icon: 'error',
            button: 'OK',
          });
        }
      },
      editVacunaDosisMujer(vacunaDosisMujer) {
        this.isEditing = true;
        this.editingVacunaDosisMujerId = vacunaDosisMujer._id;
        this.formData.dosis = vacunaDosisMujer.dosis;
        this.showForm = true;
      },
      async updateVacunaDosisMujer() {
        try {
          await axios.put(`${BASE_URL}/api/vacunadosismujer/${this.editingVacunaDosisMujerId}`, this.formData, {
            headers: {
              'x-access-token': this.$store.state.auth.user.accessToken,
            },
          });
          swal({
            title: '¡Información Actualizada!',
            text: 'La información de VacunaDosisMujer ha sido actualizada correctamente.',
            icon: 'success',
            button: 'OK',
          });
          this.clearFields();
          this.fetchVacunaDosisMujer();
          this.showForm = false;
        } catch (error) {
          swal({
            title: 'Error',
            text: `Hubo un error al editar la información de VacunaDosisMujer. \n ${error.response.data.message}.`,
            icon: 'error',
            button: 'OK',
          });
        }
      },
      cancelEdit() {
        this.showForm = false;
        this.isEditing = false;
        this.clearFields();
      },
    },
    mounted() {
      this.fetchVacunaDosisMujer();
    },
  };
  </script>
  
  <style scoped>
  /* Estilos adicionales si es necesario */
  </style>
  